import {DateTime} from 'luxon'
import {FC} from 'react'

import {Text} from '@/components/common/content/Text'
import {SuccessModal} from '@/components/common/success/SuccessModal'
import {usePreferences} from '@/components/context/Preferences'
import {useAuthContent} from '@/content/user/authentication'
import {Trans, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {formatDateAndTime} from '@/utils/formatDate'
import {useLanguage} from '@/utils/i18n/language'
import {USER_SECRET_TTL_MINUTES} from '@/utils/user/constants'

type MagicLinkSentModalProps = {
  email: string
  closeModal: () => void
  isVisible: boolean
  magicLinkExpiresAt: DateTime | null
}

export const MagicLinkSentModal: FC<MagicLinkSentModalProps> = ({
  email,
  closeModal,
  isVisible,
  magicLinkExpiresAt = null,
}) => {
  const language = useLanguage()
  const {t} = useTranslation()
  const {timezone} = usePreferences()
  const {title, description} = useAuthContent().signIn.magicLink.success

  return (
    <SuccessModal
      isVisible={isVisible}
      title={t(title)}
      description={
        <>
          {magicLinkExpiresAt && (
            <Text align="center" color={theme.palette.text.light}>
              <Trans
                i18nKey={description}
                values={{
                  email,
                  minutes: USER_SECRET_TTL_MINUTES,
                  expiresAt: formatDateAndTime(
                    magicLinkExpiresAt.toISO(),
                    language,
                    timezone,
                    true,
                  ),
                }}
              />
            </Text>
          )}
        </>
      }
      hasEmailClients
      hasSpamDescription
      onClose={closeModal}
      maxContentWidth="570px"
    />
  )
}
